module.exports = __webpack_public_path__ + "media/images/pay3-color-023ce373d25647a033abd1d1ffd14013.svg";